<!-- <div class="maincontain">
    <div *ngFor="let idx of dataRoadmap" >
        <div key={{idx.id}}>
            <div class="box">
                <div class="tf-step wow fadeInUp" data-wow-delay="0.2s">
                    <div class="boxinner">
                                <ng-lottie *ngIf="idx.animationUrl" [options]="{path: idx.animationUrl, autoplay: true, loop: true}" (animationCreated)="animationCreated"></ng-lottie>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="criteria">
  <div class="new" *ngFor="let idx of dataRoadmap">
    <div>
      <div key="{{ idx.id }}">
        <div class="new2">
          <div class="header">
            <h4>{{ idx.title }}</h4>
          </div>
          <div class="imx">
            <!-- <img src="{{lis.img}}" alt=""> -->
            <ng-lottie
              #lottie
              id="lottie_{{ idx.id }}"
              *ngIf="idx.animationUrl"
              [options]="{
                path: idx.animationUrl,
                autoplay: false,
                loop: false
              }"
              (animationCreated)="animationCreated($event, idx.id, lottie)"
            ></ng-lottie>
          </div>
          <div class="new3">
            <p>{{ idx.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
